module.exports = __webpack_public_path__ + "static/16.9_Later_Middle_Ages-3f5d5aebd9c81bbab524477afc1a1892.pdf";